import { useQuery } from '@tanstack/react-query';
import { SkillsService } from '../services/skills';
import { IBaseUseQueryProps } from '../interfaces/baseUseQueryProps';
import { IRoleWithPositionsAndSkills } from '../interfaces/role';

const GET_ROLES_WITH_POSITIONS_WITH_SKILLS_QUERY_KEY = 'get-roles-with-positions-and-skills';

export const useGetRolesWithPositionsAndSkills = (props?: IBaseUseQueryProps<IRoleWithPositionsAndSkills[]>) =>
  useQuery({
    queryKey: [GET_ROLES_WITH_POSITIONS_WITH_SKILLS_QUERY_KEY],
    queryFn: () => SkillsService.getRolesWithPositionsAndSkills(),
    refetchOnWindowFocus: false,
    staleTime: Number.MAX_SAFE_INTEGER,
    ...props
  });